import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { BaseTabs } from '@/components/ui/Tab/BaseTab';
export const FlatTabs = (props) => {
    const { children, className = '' } = props;
    return (_jsx(BaseTabs, Object.assign({ className: clsx('gap-4 md:gap-8', className) }, { children: children })));
};
